import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import DocumentTitle from 'react-document-title';

@withRouter
@inject("store")
@observer
export default class Redirect extends Component
{
    // constructor(props) 
    // {
    //     super(props);
    // }
    
    componentDidMount()
    {
        const forward = window.localStorage.getItem('forward');
        if( forward )
        {
           window.localStorage.removeItem('forward');
           this.props.history.replace(forward);
        }else
        {
            this.props.history.replace('/course');
        }
        
    }

    render()
    {
        const main = <div>Loading...</div>;
        return <DocumentTitle title={this.props.store.appname}>{main}</DocumentTitle>;
    }
}